import { createStore, combineReducers, applyMiddleware } from 'redux'

import { courierReducer, CourierState } from './reducers/couriersReducer'
import {
  typePositionReducer,
  TypePositionState,
  zoneReducer,
  ZoneState,
  WarehouseState,
  warehouseReducer,
  WorkOrderStateState,
  workOrderStateReducer,
  TypeMovementState,
  typeMovementReducer,
  typeInventoryIncidentReducer
} from './reducers'
import {
  confirmActionReducer,
  confirmaActionState
} from './reducers/confirmActionReducer'

import {
  userProfileState,
  userProfileReducer
} from './reducers/userProfileReducer'

import {
  typeAsnDocumentReducer,
  TypeAsnDocumentState
} from './reducers/typeAsnDocumentReducer'
import {
  typeAsnIncomeReducer,
  TypeAsnIncomeState
} from './reducers/typeAsnIncomeReducer'
import { asnStateReducer, AsnStatesState } from './reducers/asnStateReducer'
import {
  typeAsnSourceReducer,
  TypeAsnSourceState
} from './reducers/typeAsnSourceReducer'

import {
  otInboundStateReducer,
  OtInboundState
} from './reducers/otInboundReducer'
import {
  typeConfigurationReducer,
  TypeConfigurationState
} from './reducers/typeConfigurationReducer'

import createSagaMiddleware from 'redux-saga'

import rootSaga from './services/saga'
import { SupplierState, suppliersReducer } from './reducers/suppliersReducer'
import {
  SuppliersOriginState,
  suppliersOriginReducer
} from './reducers/supplierOriginReducer'
import { TypeInventoryIncidentState } from './reducers/typeInventoryIncidentReducer'
import { UserDataState, userDataReducer } from './reducers/userDataReducer'
import {
  ConfigurationState,
  configurationReducer
} from './reducers/configurationReducer'
import { SubZoneState, subzoneReducer } from './reducers/subzoneReducer'
import {
  productOriginsReducer,
  ProductOriginsState
} from './reducers/productOriginsReducer'
import {
  orderOriginReducer,
  OrderOriginState
} from './reducers/orderOriginsReducer'
import { typeOrderReducer, TypeOrderState } from './reducers/typesOrderReducer'
import {
  typePickingRouteReducer,
  TypePickingRouteState
} from './reducers/typesPickingRouteReducer'

import {
  typesPriorityReducer,
  TypePriorityState
} from './reducers/typesPriorityReducer'
import {
  typeStorageReducer,
  TypeStorageState
} from './reducers/typeStorageReducer'
import { typesAlertReducer, TypeAlertState } from './reducers/typesAlertReducer'

import { flowsReducer, FlowState } from './reducers/flowsReducer'
import {
  typeProcessReducer,
  TypeProcessState
} from './reducers/typeProcessReducer'
import {
  typeOperationReducer,
  TypeOperationState
} from './reducers/typeOperationReducer'

import { typeVasReducer, TypeVasState } from './reducers/typeVasReducer'
import {
  typeValidationVasReducer,
  TypeValidationVasState
} from './reducers/typeValidationVasReducer'
import { flowVasReducer, FlowVasState } from './reducers/flowVasReducer'
import {
  typeSettingReducer,
  TypeSettingState
} from './reducers/typeSettingReducer'
import { settingsReducer, SettingsState } from './reducers/settingsReducer'

export interface RootState {
  courier: CourierState
  confirmAction: confirmaActionState
  userProfile: userProfileState
  typePosition: TypePositionState
  zone: ZoneState
  warehouse: WarehouseState
  supplier: SupplierState
  supplierOrigin: SuppliersOriginState
  workOrderState: WorkOrderStateState
  typeMovement: TypeMovementState
  typeAsnDocument: TypeAsnDocumentState
  typeAsnIncome: TypeAsnIncomeState
  asnState: AsnStatesState
  typeAsnSource: TypeAsnSourceState
  otInbound: OtInboundState
  typeConfiguration: TypeConfigurationState
  typeInventoryIncident: TypeInventoryIncidentState
  configuration: ConfigurationState
  userData: UserDataState
  subzone: SubZoneState
  productOrigin: ProductOriginsState
  orderOrigin: OrderOriginState
  typeOrder: TypeOrderState
  typePickingRoute: TypePickingRouteState
  typePriority: TypePriorityState
  typeStorage: TypeStorageState
  typeAlert: TypeAlertState
  flow: FlowState
  typeProcess: TypeProcessState
  typeOperation: TypeOperationState
  typeVas: TypeVasState
  typeValidationVas: TypeValidationVasState
  flowVas: FlowVasState
  typeSetting: TypeSettingState
  settings: SettingsState
}

const reducers = combineReducers<RootState>({
  courier: courierReducer,
  confirmAction: confirmActionReducer,
  userProfile: userProfileReducer,
  typePosition: typePositionReducer,
  zone: zoneReducer,
  warehouse: warehouseReducer,
  supplier: suppliersReducer,
  supplierOrigin: suppliersOriginReducer,
  workOrderState: workOrderStateReducer,
  typeMovement: typeMovementReducer,
  typeAsnDocument: typeAsnDocumentReducer,
  typeAsnIncome: typeAsnIncomeReducer,
  asnState: asnStateReducer,
  typeAsnSource: typeAsnSourceReducer,
  otInbound: otInboundStateReducer,
  typeConfiguration: typeConfigurationReducer,
  typeInventoryIncident: typeInventoryIncidentReducer,
  userData: userDataReducer,
  configuration: configurationReducer,
  subzone: subzoneReducer,
  productOrigin: productOriginsReducer,
  orderOrigin: orderOriginReducer,
  typeOrder: typeOrderReducer,
  typePickingRoute: typePickingRouteReducer,
  typePriority: typesPriorityReducer,
  typeStorage: typeStorageReducer,
  typeAlert: typesAlertReducer,
  flow: flowsReducer,
  typeProcess: typeProcessReducer,
  typeOperation: typeOperationReducer,
  typeVas: typeVasReducer,
  typeValidationVas: typeValidationVasReducer,
  flowVas: flowVasReducer,
  typeSetting: typeSettingReducer,
  settings: settingsReducer
})

const sagaMiddleware = createSagaMiddleware()

const store = createStore(reducers, applyMiddleware(sagaMiddleware))

sagaMiddleware.run(rootSaga)

export { store }


